import React from 'react';
import PropTypes from 'prop-types';

import { OContactFormBasic, OContactFormHousehold } from '../';
import { AButton } from '../../atoms';

export default class OContactHouseHold extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			familyName: props.familyName,
			name: props.name,
			tel: props.tel,
			email: props.email,
			subject: props.subject,
			message: props.message,
			isFormValid: props.isFormValid,
		};

		this.bindHandles();
	}

	componentWillReceiveProps(props) {
		const keys = ['familyName', 'name', 'tel', 'email', 'subject', 'message', 'isFormValid'];

		keys.forEach((key) => {
			if (props[key] !== this.state[key]) {
				this.setState({ [key]: props[key] });
			}
		});
	}

	bindHandles() {
		this.handleFieldChange = this.handleFieldChange.bind(this);
		this.handleFileChange = this.handleFileChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleFieldChange({ field, value, error }) {
		if (this.props.onChange) {
			this.props.onChange({ [field]: { value, valid: !error } });
		}
	}

	handleSubmit() {
		if (this.props.onSubmit) {
			this.props.onSubmit();
		}
	}

	handleFileChange(value) {
		if (this.props.onChange) {
			this.props.onChange({ file: { value, valid: true } });
		}
	}

	render() {
		return (
			<article className="o-contact-form">
				<OContactFormBasic
					familyName={this.state.familyName}
					name={this.state.name}
					telephone={this.state.tel}
					email={this.state.email}
					onFamilyNameChange={(value, error) => this.handleFieldChange({ field: 'familyName', value, error })}
					onNameChange={(value, error) => this.handleFieldChange({ field: 'name', value, error })}
					onTelephoneChange={(value, error) => this.handleFieldChange({ field: 'tel', value, error })}
					onEmailChange={(value, error) => this.handleFieldChange({ field: 'email', value, error })}
				/>
				<OContactFormHousehold
					subject={this.state.subject}
					file={this.state.file}
					message={this.state.message}
					onSubjectChange={(value, error) => this.handleFieldChange({ field: 'subject', value, error })}
					onFileChange={this.handleFileChange}
					onMessageChange={(value, error) => this.handleFieldChange({ field: 'message', value, error })}
				/>
				<div className="align-wrapper">
					<AButton
						type="send"
						value="FORM.SEND"
						onClick={this.handleSubmit}
						disabled={!this.state.isFormValid}
					/>
				</div>
			</article>
		);
	}
}

OContactHouseHold.propTypes = {
	familyName: PropTypes.string,
	name: PropTypes.string,
	tel: PropTypes.string,
	email: PropTypes.string,
	subject: PropTypes.string,
	message: PropTypes.string,
	isFormValid: PropTypes.bool,
	onSubmit: PropTypes.func,
	onChange: PropTypes.func,
};

OContactHouseHold.defaultProps = {
	familyName: '',
	name: '',
	tel: '',
	email: '',
	subject: '',
	message: '',
	isFormValid: false,
	onSubmit: undefined,
	onChange: undefined,
};




// WEBPACK FOOTER //
// ./src/components/organisme/contact/_organisme.contact-household.js